import { _ as t } from "../internals/export.js";
import { f as r } from "../internals/function-uncurry-this.js";
import { t as e } from "../internals/to-integer-or-infinity.js";
var i = Date.prototype,
  n = r(i.getTime),
  o = r(i.setFullYear);
t({
  target: "Date",
  proto: !0
}, {
  setYear: function setYear(t) {
    n(this);
    var r = e(t);
    return o(this, 0 <= r && r <= 99 ? r + 1900 : r);
  }
});